import { render, staticRenderFns } from "./detail-gopay.vue?vue&type=template&id=0b9cd0a4&"
import script from "./detail-gopay.vue?vue&type=script&lang=js&"
export * from "./detail-gopay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports